export default __webpack_public_path__ + "static/media/1.3eb70421.png";